import { IonContent, IonDatetime, IonIcon, IonPage } from '@ionic/react';
import { SidebarMenu, ImageVisualizer, ModalBackground, SolidButton, } from 'components';
import React, { useState, useEffect } from 'react';
import { FirebaseDB } from "firebase-config";
import { getReportPromotion, getBrandList } from 'services/reportePromo.service';
import { useAppSelector } from 'hooks';
import { collection, getDocs, query, where, Timestamp } from "firebase/firestore";

import { caretDown } from 'ionicons/icons';
import { Accordion, AccordionDetails, AccordionSummary, Checkbox, FormControlLabel } from '@mui/material';
import { formatDateToLocaleDateString, formatDateToISODateString } from 'utils';



export default function ReportePromo() {
    const today = new Date();
    const todayAux = new Date();
    const { uid } = useAppSelector((state) => state.user);
    const [reportData, setReportData] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);

    const [startDate, setStartDate] = useState<Date>(new Date(todayAux.setDate(todayAux.getDate() - 30)));
    const [finishDate, setFinishDate] = useState<Date>(new Date());
    //console.log("StartDate incializima", startDate, "FinishDate Finalizima", finishDate);
    // const [withPromotionsCount, setWithPromotionsCount] = useState(0);
    // const [withoutPromotionsCount, setWithoutPromotionsCount] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [totalBranches, setTotalBranches] = useState(0);
    const [sucursalesAgrupadas, setSucursalesAgrupadas] = useState<any[]>([]);
    const [imagesToShow, setImagesToShow] = useState<string[]>([]);
    const [showImageModal, setShowImageModal] = useState<boolean>(false);

    const [startDateSearchFilter, setStartDateSearchFilter] = useState<Date>(new Date(startDate));
    const [finishDateSearchFilter, setFinishDateSearchFilter] = useState<Date>(new Date(finishDate));

    const [brands, setBrands] = useState<any[]>([]);
    const [filteredBenchmarks, setFilteredBenchmarks] = useState<any[]>([]);

    const changeStartDateHandler = (stringDate?: string | string[] | null) => {
        //console.log("stringDate", stringDate);
        let aaa = parseLocalDateToTimestamp(stringDate as string, true);

        //console.log("aaa", aaa.toDate());

        let f = stringDate && !Array.isArray(stringDate) ? new Date(stringDate) : new Date();
        let fecha = Timestamp.fromDate(f);




        //console.log("fechita2", fecha.toDate());

        if (stringDate && !Array.isArray(stringDate)) {
            const f = new Date(stringDate); // Convierte el string a un objeto Date
            const fecha = Timestamp.fromDate(f); // Convierte a Timestamp
            //console.log("fechita2", fecha.toDate()); // Muestra el valor en consola

            setStartDateSearchFilter(aaa.toDate()); // Actualiza el estado con el valor de fecha.toDate()
        }
    };

    const changeFinishDateHandler = (stringDate?: string | string[] | null) => {
        //console.log("stringDate", stringDate);
        let aaa = parseLocalDateToTimestamp(stringDate as string, false);

        //console.log("aaa", aaa.toDate());

        let f = stringDate && !Array.isArray(stringDate) ? new Date(stringDate) : new Date();
        let fecha = Timestamp.fromDate(f);
        if (stringDate && !Array.isArray(stringDate)) {
            const f = new Date(stringDate); // Convierte el string a un objeto Date
            const fecha = Timestamp.fromDate(f); // Convierte a Timestamp


            setFinishDateSearchFilter(aaa.toDate()); // Actualiza el estado con el valor de fecha.toDate()
        }
    };

    // Nueva fecha 
    function parseLocalDateToTimestamp(dateString: string, init: boolean): Timestamp {
        const [year, month, day] = dateString.split('-').map(Number);
        const date = new Date(year, month - 1, day);
        if (!init) date.setHours(23, 59, 59, 999);
        return Timestamp.fromDate(date);
    }

    const parseDate = (dateString: string): Date | null => {
        const [day, month, year] = dateString.split('/').map(Number);
        if (!day || !month || !year || isNaN(day) || isNaN(month) || isNaN(year)) return null;
        const date = new Date(year, month - 1, day);
        return isNaN(date.getTime()) ? null : date;
    };


    const filterPromotionsByDate = (promotions: any[], startDate: Date, finishDate: Date) => {
        return promotions.filter((promo) => {
            const promoStartDate = parseDate(promo.datePromotion);
            const promoEndDate = parseDate(promo.endPromotion);

            if (!promoStartDate || !promoEndDate) return false;

            // Verifica si las fechas de la promoción están dentro del rango
            const isWithinDateRange = promoStartDate <= finishDate && promoEndDate >= startDate;


            return isWithinDateRange
        });
    };

    const applyDateFilter = () => {
        // Actualiza el estado para reflejar los nuevos valores seleccionados
        setStartDate(startDateSearchFilter);
        setFinishDate(finishDateSearchFilter);

        // Llama a getBenchmarkDocs con los valores de los filtros directamente
        getBenchmarkDocs(startDateSearchFilter, finishDateSearchFilter);
    };
    //console.log("Aplicando filtro con fechas:", startDate, finishDate);

    const getBenchmarkDocs = async (startDateParam: Date, finishDateParam: Date) => {
        try {
            const benchmarkRef = collection(FirebaseDB, "benchmarks");

            const reportQuery = query(
                benchmarkRef,
                where("listPromotions.contains", "==", true),
                where("created_at", ">=", startDateParam),
                where("created_at", "<=", finishDateParam),
                where("test", "==", false),
            );

            const querySnapshot = await getDocs(reportQuery);

            const benchmarksPromises = querySnapshot.docs.map(async (doc) => {
                const data = doc.data();

                if (!uid) {
                    console.error("UID is not available");
                    return null;
                }

                let promotions = await getReportPromotion(uid, data.$key);

                // Filtrar las promociones por rango de fechas y marcas seleccionadas
                promotions = filterPromotionsByDate(promotions, startDateParam, finishDateParam);

                data.promotions = promotions;

                return {
                    id: doc.id,
                    ...data,
                    hasPromotion: !!data.promotion,
                    sucursal: data.sucursal || 0,
                    nameSucursal: data.nameSucursal || "",
                };
            });

            const benchmarks = await Promise.all(benchmarksPromises);

            const uniqueBranches = new Set();
            const sucursalesAgrupadasAux: any[] = [];

            benchmarks.forEach((b) => {
                if (!b) return;

                if (b?.sucursal) {
                    uniqueBranches.add(b.sucursal);
                }

                const grupoExistente = sucursalesAgrupadasAux.find(g => g.code === b.sucursal);
                if (grupoExistente) {
                    grupoExistente.data.push(b);
                } else {
                    sucursalesAgrupadasAux.push({
                        code: b.sucursal,
                        name: b.nameSucursal,
                        data: [b],
                    });
                }
            });

            //console.log(sucursalesAgrupadas, "sucursalitas");

            setSucursalesAgrupadas(sucursalesAgrupadasAux);
            setTotalCount(benchmarks.length);
            setTotalBranches(uniqueBranches.size);
            setReportData(benchmarks);

        } catch (error) {
            console.error("Error fetching benchmarks:", error);
        } finally {
            setLoading(false);
        }
    };

    // const handleBrandSelection = (event: React.ChangeEvent<HTMLInputElement>, brandId: string) => {
    //     if (event.target.checked) {
    //         setSelectedBrands((prev) => [...prev, brandId]);
    //     } else {
    //         setSelectedBrands((prev) => prev.filter((id) => id !== brandId));
    //     }
    // };

    useEffect(() => {
        fetchBrands();
        getBenchmarkDocs(startDate, finishDate);
    }, []);

    const showImageHandler = (images: string[]) => {
        const imagesArray = Array.isArray(images) ? images : [images];
        setImagesToShow(imagesArray);
        setShowImageModal(true);
    }

    const fetchBrands = async () => {
        if (!uid) return;

        const brandList = await getBrandList(uid);
        if (brandList) {
            const formattedBrands = brandList.map((brand: any) => ({
                value: brand.id,
                label: brand.label,
                checked: true, // Por defecto, todas las marcas están seleccionadas
                visible: true, // Todas las marcas son visibles inicialmente
            }));
            setBrands(formattedBrands);
        }
    };

    const handleBrandFilterChange = (event: React.ChangeEvent<HTMLInputElement>, brandId: string) => {
        const updatedBrands = brands.map((brand) =>
            brand.value === brandId ? { ...brand, checked: event.target.checked } : brand
        );

        setBrands(updatedBrands);
        updateFilteredBenchmarks(updatedBrands);
    };

    const updateFilteredBenchmarks = (updatedBrands: any[]) => {
        const selectedBrandIds = updatedBrands.filter((brand) => brand.checked).map((brand) => brand.value);

        // Filtrar benchmarks por marcas seleccionadas
        const filtered = reportData.map((benchmark) => {
            const filteredPromotions = benchmark.promotions.filter((promo: any) =>
                selectedBrandIds.includes(promo.brandId)
            );

            return {
                ...benchmark,
                promotions: filteredPromotions,
            };
        }).filter((benchmark) => benchmark.promotions.length > 0); // Elimina benchmarks sin promociones

        // Agrupar los benchmarks filtrados por sucursales
        const uniqueBranches = new Set();
        const sucursalesAgrupadasAux: any[] = [];

        filtered.forEach((b) => {
            if (!b) return;

            if (b?.sucursal) {
                uniqueBranches.add(b.sucursal);
            }

            const grupoExistente = sucursalesAgrupadasAux.find((g) => g.code === b.sucursal);
            if (grupoExistente) {
                grupoExistente.data.push(b);
            } else {
                sucursalesAgrupadasAux.push({
                    code: b.sucursal,
                    name: b.nameSucursal,
                    data: [b],
                });
            }
        });

        setSucursalesAgrupadas(sucursalesAgrupadasAux);
    };


    const resetDateFilters = () => {
        // Restablece los filtros a las fechas iniciales
        setStartDateSearchFilter(new Date(startDate));
        setFinishDateSearchFilter(new Date());

        // Actualiza el estado principal de las fechas
        setStartDate(new Date(startDate));
        setFinishDate(new Date(finishDate));
        applyDateFilter();

        // Llama a getBenchmarkDocs con las fechas iniciales
    };



    return (
        <IonPage>
            <IonContent>
                <div className="w-full h-screen grid grid-cols-12">
                    <div className="col-span-2 border-r-2 border-solid border-light">
                        <SidebarMenu pageName="example" />
                    </div>
                    <div className="w-full h-full flex flex-col col-span-10 overflow-y-scroll">
                        <div className="w-full flex justify-between border-b-2 border-tertiary px-4 py-3">
                            <h1 className="text-2xl font-bold text-primary">Reporte de Promociones</h1>
                            <p className="font-semibold text-lg">Del {formatDateToLocaleDateString(startDate)} al {formatDateToLocaleDateString(finishDate)}</p>
                        </div>
                        <div id="main-section" className="h-full overflow-y-scroll p-4 flex ">
                            <div className="flex flex-col w-full">
                                {sucursalesAgrupadas.length === 0 ? (
                                    // Mostrar mensaje si no hay resultados
                                    <div className="w-max p-4 bg-white shadow-sm">
                                        <p className="text-center text-gray-500 font-semibold">
                                            No se encontraron resultados para las fechas seleccionadas.
                                        </p>
                                    </div>
                                ) : (
                                    // Renderizar los acordeones si hay resultados
                                    sucursalesAgrupadas.map((sucursal: any, index: number) => (
                                        <Accordion key={index} defaultExpanded={false}>
                                            <AccordionSummary
                                                expandIcon={<IonIcon icon={caretDown} className="text-[25px] text-black" />}
                                                aria-controls={`panel${index}-content`}
                                                id={`panel${index}-header`}
                                                sx={{ backgroundColor: '#F4F5F5' }}
                                            >
                                                <div className="items-center grid grid-cols-1 gap-4 text-mid">
                                                    <p className="font-semibold">Sucursal: <span className="pl-2">{sucursal.name}</span></p>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="pt-4 pb-1 grid grid-cols-7 gap-4 text-mid border-b-2 border-tertiary [&>p]:mt-auto [&>p]:text-primary [&>p]:font-semibold">
                                                    <p>Nombre de Promoción</p>
                                                    <p>Precio Regular</p>
                                                    <p>Precio Promoción</p>
                                                    <p>Fecha de inicio</p>
                                                    <p>Fecha de finalización</p>
                                                    <p>Marca</p>
                                                    <p>Imagen</p>
                                                </div>
                                                <div className="flex flex-col gap-4 mt-4">
                                                    {sucursal.data.map((benchmark: any, idx: number) => (
                                                        <React.Fragment key={idx}>
                                                            {benchmark.promotions?.map((promo: any, promoIdx: number) => (
                                                                <div
                                                                    key={promoIdx}
                                                                    className="bg-white cursor:pointer [&>div]:text-ellipsis [&>div]:overflow-hidden [&>div]:... [&>div]:p-2 text-sm text-gray-700 grid grid-cols-7"
                                                                >
                                                                    <p>{promo.name}</p>
                                                                    <p>{promo.priceRegular ?? 'N/A'}</p>
                                                                    <p>{promo.pricePromotion ?? 'N/A'}</p>
                                                                    <p>{promo.datePromotion ?? 'Sin observaciones'}</p>
                                                                    <p>{promo.endPromotion ?? 'Sin observaciones'}</p>
                                                                    <p>{promo.brandId ?? 'Marca no asignada'}</p>
                                                                    {promo.image ? (
                                                                        <button
                                                                            className="bg-tertiary hover:opacity-80 font-semibold px-2 py-1 rounded-lg text-small"
                                                                            onClick={() => showImageHandler([promo.image])}
                                                                        >
                                                                            Ver imagen
                                                                        </button>
                                                                    ) : (
                                                                        <p className="text-gray-500">Sin imagen</p>
                                                                    )}
                                                                </div>
                                                            ))}
                                                        </React.Fragment>
                                                    ))}
                                                </div>
                                            </AccordionDetails>
                                        </Accordion>
                                    ))
                                )}
                            </div>
                            {/* Filtros */}
                            <div className="overflow-y-scroll flex p-2 flex-col  order-last border-l-2 border-light">
                                {/* <SolidButton
                                    text="Restablecer"
                                    backgroundColor="primary"
                                    disabled={false}
                                    onClickHandler={resetDateFilters}
                                /> */}
                                {/* Filtro de fechas */}
                                <Accordion >
                                    <AccordionSummary
                                        expandIcon={<IonIcon icon={caretDown} className="text-[18px] text-black" />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <p className="font-semibold text-mid">Fecha</p>

                                    </AccordionSummary>

                                    <AccordionDetails>
                                        <div className="flex flex-col items-center gap-12">
                                            <div className="flex flex-col gap-2">
                                                <p className="font-semibold">Fecha de inicio</p>
                                                <IonDatetime
                                                    presentation="date"
                                                    value={formatDateToISODateString(startDateSearchFilter)}
                                                    max={formatDateToISODateString(today)}
                                                    onIonChange={(event) => changeStartDateHandler(event.detail.value)}
                                                />
                                            </div>

                                            <div className="flex flex-col gap-2">
                                                <p className="font-semibold">Fecha de fin</p>
                                                <IonDatetime
                                                    presentation="date"
                                                    value={formatDateToISODateString(finishDateSearchFilter)}
                                                    max={formatDateToISODateString(today)}
                                                    onIonChange={(event) => changeFinishDateHandler(event.detail.value)}
                                                />
                                            </div>

                                            <div className="w-full xl:w-1/2">
                                                <SolidButton
                                                    text="Aplicar"
                                                    backgroundColor="primary"
                                                    disabled={false}
                                                    onClickHandler={applyDateFilter}
                                                />
                                            </div>
                                        </div>
                                    </AccordionDetails>
                                </Accordion>
                                {/* Filtro de marcas */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<IonIcon icon={caretDown} className="text-[18px] text-black" />}
                                        aria-controls="panel-brand-filter"
                                        id="panel-brand-filter"
                                    >
                                        <p className="font-semibold text-mid">Marcas</p>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <div className="flex flex-col">
                                            {brands.length === 0 && (
                                                <p className="font-semibold text-primary">No hay marcas disponibles</p>
                                            )}
                                            {brands.map((brand) => (
                                                <FormControlLabel
                                                    key={brand.value}
                                                    label={brand.label}
                                                    control={
                                                        <Checkbox
                                                            checked={brand.checked}
                                                            onChange={(event) => handleBrandFilterChange(event, brand.value)}
                                                        />
                                                    }
                                                />
                                            ))}
                                        </div>
                                    </AccordionDetails>
                                </Accordion>
                            </div>

                        </div>
                    </div>
                </div>
            </IonContent>
            {
                showImageModal &&
                <ModalBackground />
            }

            {
                showImageModal &&
                <ImageVisualizer imageArray={imagesToShow} imageAlt="Imagen Promo" clickOutsideHandler={() => setShowImageModal(false)} />
            }
        </IonPage>
    );
}